import message, { epics as messageEpics } from './message';

export const epics = [
  ...messageEpics,
];

export default message;
